class CampaignTimer extends HTMLElement {
  constructor() {
    super();

    const useCustom = this.dataset.useCustom === 'true';
    const isoDate = this.dataset.iso;
    const hideDays = this.dataset.hideDays === 'true';
    const shop = (window.Shopify && window.Shopify.shop) || '';
    const offset = (this.dataset.timezone || '').trim();
    const template = (this.dataset.template || 'html').toLowerCase();
    this.template = template;

    this.hideDays = hideDays;

    if (useCustom && isoDate) {
      this.endDate = new Date(isoDate).getTime();
    } else {
      const today = new Date();
      const next = new Date(today);
      next.setDate(today.getDate() + 1);
      // Default to +02:00, allow override via data-timezone, special case for India shop
      let timezone = offset || '+02:00';
      if (!offset && shop === 'swati-india.myshopify.com') timezone = '+05:30';

      const dd = String(next.getDate()).padStart(2, '0');
      const mm = String(next.getMonth() + 1).padStart(2, '0');
      const yyyy = next.getFullYear();
      const nextISO = `${yyyy}-${mm}-${dd}T00:00:00${timezone}`;
      this.endDate = new Date(nextISO).getTime();
    }

    this.labels = {
      day: this.dataset.tDay || 'Day',
      hours: this.dataset.tHours || 'Hours',
      minutes: this.dataset.tMinutes || 'Min',
      seconds: this.dataset.tSeconds || 'Sec',
      endingIn: this.dataset.tEndingIn || 'Ending in:'
    };

    this.init();
  }

  /**
   * @param {number} n
   * @returns {string}
   */
  toTwoDigits(n) {
    return n < 10 ? `0${n}` : String(n);
  }

  /**
   * @param {number} days
   * @param {number} hours
   * @param {number} minutes
   * @param {number} seconds
   * @returns {string}
   */
  renderHTML(days, hours, minutes, seconds) {
    return `
      <div class="campaign-timer__inner">
        ${
          this.hideDays
            ? ''
            : `<div class="campaign-timer__unit"><span>${this.toTwoDigits(days)}</span><strong>${this.labels.day}</strong></div><span class="campaign-timer__sep">:</span>`
        }
        <div class="campaign-timer__unit"><span>${this.toTwoDigits(hours)}</span><strong>${this.labels.hours}</strong></div><span class="campaign-timer__sep">:</span>
        <div class="campaign-timer__unit"><span>${this.toTwoDigits(minutes)}</span><strong>${this.labels.minutes}</strong></div><span class="campaign-timer__sep">:</span>
        <div class="campaign-timer__unit"><span>${this.toTwoDigits(seconds)}</span><strong>${this.labels.seconds}</strong></div>
      </div>
    `;
  }

  /**
   * @param {number} days
   * @param {number} hours
   * @param {number} minutes
   * @param {number} seconds
   * @returns {string}
   */
  renderText(days, hours, minutes, seconds) {
    return `${this.toTwoDigits(hours)}:${this.toTwoDigits(minutes)}:${this.toTwoDigits(seconds)}`;
  }

  init() {
    const distance = () => this.endDate - Date.now();
    if (this.endDate && distance() > 0) {
      const id = setInterval(() => {
        const d = distance();
        const days = Math.floor(d / (1000 * 60 * 60 * 24));
        const hours = Math.floor((d % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((d % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((d % (1000 * 60)) / 1000);

        if (this.template === 'text') {
          this.textContent = this.renderText(days, hours, minutes, seconds);
        } else {
          this.innerHTML = this.renderHTML(days, hours, minutes, seconds);
        }

        if (distance() <= 0) {
          clearInterval(id);
          this.innerHTML = '';
          try {
            localStorage.removeItem('fbPromoCode');
            localStorage.removeItem('fbPromoEndTime');
          } catch (e) {}
        }
      }, 1000);
    } else {
      this.innerHTML = '';
    }
  }
}

customElements.define('campaign-timer', CampaignTimer);


